import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

interface CalculatePriceCard {
  wantListId: number;
  cardId?: string;  // Specific card ID for exact version matching
  condition: string;
  language: string;
  foil: boolean;
  set?: string;
}

interface CalculatePriceRequest {
  cards: CalculatePriceCard[];
}

interface CalculatePriceResponse {
  cards: Array<{
    wantListId: number;
    displayPrice: number;
    languageMultiplierApplied?: boolean;
    multiplierValue?: number;
  }>;
}

export const tradePriceApi = createApi({
  reducerPath: 'tradePriceApi',
  baseQuery,
  endpoints: (builder) => ({
    calculatePrice: builder.mutation<CalculatePriceResponse, CalculatePriceRequest>({
      query: (data) => ({
        url: '/trades/calculate-price',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useCalculatePriceMutation } = tradePriceApi;